// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{margin:0;padding:0;}
a {color:var(--text-color);text-decoration:none;}

#wrap{
  position:relative;
  left:0; top:0;
  width:200%;
  height:100%;
  display:flex;
  align-items:stretch;
  margin:0 25%;
}

.innovation{
  height: 100vh;
  overflow: hidden;
}

.innovation h2{
  position: absolute;
  margin-top: 10%;
  left: 45%;
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--text-color);
  z-index: 3;
}

.innovation .hb {
  cursor: auto;
  position:relative;
  width:25%;
  display:flex;
  align-items:center;
  z-index:2;
  transform:scale(.97);
}
.innovation .c{
  position:relative;
  display:block;
  max-width:90%;
}
.innovation .c img {
  position:relative;
  display:block;
  width:110%;
  height:auto;
  z-index:2;
  border-radius: 15px;
}
.innovation .txt {
  position:absolute;
  color: var(--text-color);
  top:100%; left:10%;
  width:80%;
  opacity:0;
  padding:1em 0 0 1em;
  border-left:1px solid;
  z-index:1;
  transform:scaleY(1) translateY(-50px);
  transition:transform .2s, opacity .5s;
}

.innovation{
  .card{
    align-items: center;
    position: relative;
    width: 105%;
    height: 105px;
    box-shadow: 20px 20px 50px rgba(0, 0, 0, 0.5);
    border-radius: 15px;
    background: rgba(9, 7, 11, 0.529);
    overflow: hidden;
    display: flex;
    border-top: 1px solid var(--text-color);
    border-left: 1px solid var(--text-color);
    -webkit-backdrop-filter: blur(3px);
            backdrop-filter: blur(3px);
}
}

.innovation .card p{
  margin-left: 10px;
  color: white;
}

.innovation .ico{
  display: flex;
  justify-content: flex-end;
}

.innovation .ico a{
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  background: transparent;
  border: .2rem solid var(--main-color);
  border-radius: 50%;
  font-size: 2rem;
  color: var(--text-color);
  margin-top: -20px;
  transition: .5s ease;
}

.innovation .ico a:hover{
  background: var(--main-color);
  color:var(--text-color);
  box-shadow: 0 0 1rem var(--main-color)
}

.innovation h1 {
  width: 300px;
  font-size:1.2em;
  font-weight:700;
  color: var(--main-color);
  text-transform:uppercase;
}
.innovation .hb:hover .txt {
  opacity:1;
  transform:scaleY(1) translateY(0);
}
.innovation .fullBg {
  position:absolute;
  top:0;
  left:-12%;
  width:100%;
  height:100%;
  opacity:0;
  transition:transform .5s, opacity .5s;
  transform:scale(1);
  z-index:1;
}
.innovation .fullBg img {
  width:50%;height:100%;
  object-fit:cover;object-position:center;
  opacity:.5;
}
.innovation .hb:hover + .fullBg {opacity:1;transform:scale(1.02);}
.innovation .credits {
  position:fixed;
  bottom:0;right:0;
  padding:1.5em;
  font-size:.8em;
  text-align:right;
  font-style:italic;
  opacity:.8;
  transition:opacity .2;
  z-index:3;
}
.innovation .credits:hover {
  text-decoration:underline;
  opacity:1;
}

@media(max-width:800px){

  .innovation h2{
    position: absolute;
    margin-top: 10%;
    left: 45%;
  }

  .innovation .c img {
    width: 150px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Innovations/Inno-desk.css"],"names":[],"mappings":"AAAA,EAAE,QAAQ,CAAC,SAAS,CAAC;AACrB,GAAG,uBAAuB,CAAC,oBAAoB,CAAC;;AAEhD;EACE,iBAAiB;EACjB,MAAM,EAAE,KAAK;EACb,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,QAAQ,EAAE,QAAQ;EAClB,SAAS;EACT,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;EACT,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,6CAA6C;IAC7C,mBAAmB;IACnB,iCAAiC;IACjC,gBAAgB;IAChB,aAAa;IACb,uCAAuC;IACvC,wCAAwC;IACxC,kCAA0B;YAA1B,0BAA0B;AAC9B;AACA;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,iCAAiC;AACnC;AACA;EACE,iBAAiB;EACjB,KAAK;EACL,SAAS;EACT,UAAU;EACV,WAAW;EACX,SAAS;EACT,qCAAqC;EACrC,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,SAAS,CAAC,WAAW;EACrB,gBAAgB,CAAC,sBAAsB;EACvC,UAAU;AACZ;AACA,iCAAiC,SAAS,CAAC,qBAAqB,CAAC;AACjE;EACE,cAAc;EACd,QAAQ,CAAC,OAAO;EAChB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;;EAEE;IACE,kBAAkB;IAClB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["*{margin:0;padding:0;}\na {color:var(--text-color);text-decoration:none;}\n\n#wrap{\n  position:relative;\n  left:0; top:0;\n  width:200%;\n  height:100%;\n  display:flex;\n  align-items:stretch;\n  margin:0 25%;\n}\n\n.innovation{\n  height: 100vh;\n  overflow: hidden;\n}\n\n.innovation h2{\n  position: absolute;\n  margin-top: 10%;\n  left: 45%;\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--text-color);\n  z-index: 3;\n}\n\n.innovation .hb {\n  cursor: auto;\n  position:relative;\n  width:25%;\n  display:flex;\n  align-items:center;\n  z-index:2;\n  transform:scale(.97);\n}\n.innovation .c{\n  position:relative;\n  display:block;\n  max-width:90%;\n}\n.innovation .c img {\n  position:relative;\n  display:block;\n  width:110%;\n  height:auto;\n  z-index:2;\n  border-radius: 15px;\n}\n.innovation .txt {\n  position:absolute;\n  color: var(--text-color);\n  top:100%; left:10%;\n  width:80%;\n  opacity:0;\n  padding:1em 0 0 1em;\n  border-left:1px solid;\n  z-index:1;\n  transform:scaleY(1) translateY(-50px);\n  transition:transform .2s, opacity .5s;\n}\n\n.innovation{\n  .card{\n    align-items: center;\n    position: relative;\n    width: 105%;\n    height: 105px;\n    box-shadow: 20px 20px 50px rgba(0, 0, 0, 0.5);\n    border-radius: 15px;\n    background: rgba(9, 7, 11, 0.529);\n    overflow: hidden;\n    display: flex;\n    border-top: 1px solid var(--text-color);\n    border-left: 1px solid var(--text-color);\n    backdrop-filter: blur(3px);\n}\n}\n\n.innovation .card p{\n  margin-left: 10px;\n  color: white;\n}\n\n.innovation .ico{\n  display: flex;\n  justify-content: flex-end;\n}\n\n.innovation .ico a{\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  background: transparent;\n  border: .2rem solid var(--main-color);\n  border-radius: 50%;\n  font-size: 2rem;\n  color: var(--text-color);\n  margin-top: -20px;\n  transition: .5s ease;\n}\n\n.innovation .ico a:hover{\n  background: var(--main-color);\n  color:var(--text-color);\n  box-shadow: 0 0 1rem var(--main-color)\n}\n\n.innovation h1 {\n  width: 300px;\n  font-size:1.2em;\n  font-weight:700;\n  color: var(--main-color);\n  text-transform:uppercase;\n}\n.innovation .hb:hover .txt {\n  opacity:1;\n  transform:scaleY(1) translateY(0);\n}\n.innovation .fullBg {\n  position:absolute;\n  top:0;\n  left:-12%;\n  width:100%;\n  height:100%;\n  opacity:0;\n  transition:transform .5s, opacity .5s;\n  transform:scale(1);\n  z-index:1;\n}\n.innovation .fullBg img {\n  width:50%;height:100%;\n  object-fit:cover;object-position:center;\n  opacity:.5;\n}\n.innovation .hb:hover + .fullBg {opacity:1;transform:scale(1.02);}\n.innovation .credits {\n  position:fixed;\n  bottom:0;right:0;\n  padding:1.5em;\n  font-size:.8em;\n  text-align:right;\n  font-style:italic;\n  opacity:.8;\n  transition:opacity .2;\n  z-index:3;\n}\n.innovation .credits:hover {\n  text-decoration:underline;\n  opacity:1;\n}\n\n@media(max-width:800px){\n\n  .innovation h2{\n    position: absolute;\n    margin-top: 10%;\n    left: 45%;\n  }\n\n  .innovation .c img {\n    width: 150px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
